module.exports = __webpack_public_path__ + "img/icon_material_cumulative_gj_2.8b92d283.webp";